module.exports = __webpack_public_path__ + "img/bg_rental-suites.ad428733.jpg";